import api from '@pray/shared/utils/api';

import type { WarmupCampaign } from './types';

export async function duplicateWarmupCampaign({
  artistId,
  warmupCampaignId,
}: {
  artistId: string;
  warmupCampaignId: string;
}): Promise<{ object: WarmupCampaign }> {
  if (!artistId) throw new Error('Artist ID is required');
  if (!warmupCampaignId) throw new Error('Warmup campaign ID is required');

  const url = `/web/studio/artists/${artistId}/warmup-campaigns/${warmupCampaignId}/duplicate`;
  const response = await api.executePostRequest<{ data: { object: WarmupCampaign } }>(url, {});
  return response.data.data;
}
